import "./ActiveAssetDashboard.scss";
import { Breadcrumb, Card, Col, Label, ModalPopup, SofturaTable, Tooltip, EventHandler } from 'client/CommonComponents';
import fuelcardicon from "../../../assets/images/Icon_Fuel.svg";
import linkicon from "../../../assets/images/LinkLinear.png";
import dollaricon from "../../../assets/images/DollarLinear.png"
import companyicon from "../../../assets/images/Icon_Company.svg";
import yearicon from "../../../assets/images/Icon_Calendar.svg";
import modelicon from "../../../assets/images/Icon_Model.svg";
import comingsoon from "../../../assets/images/coming_soon.png";
import moment from "moment";
import './ActiveAssetAuditHistory'
import ActiveAssetAuditHistory from "./ActiveAssetAuditHistory";
import AssetImage from "client/Components/OrderManagement/Reports/BarcodeReport/AssetImage";

const ActiveAssetDashboard = ({
    breadcrumlist,
    columns,
    handleClickBack,
    assetEoneDetails,
    onClickOrder,
    onClickAssetNumber,
    onClickAuditCycleYear,
    showModalPopup,
    closeModalPopup,
    getAuditName,
    auditHistoryDetails,
    audithistory_columns,
    audithistory_data,
    itemStatus,
    handleLocationClick,
    handleImageClick,
    onClickAssetImages,
    popupcontent,
    displayValue
}: any) => {
    return (
        <>
            <div className='breadCrumbBlock'>
                <EventHandler onEvent={handleClickBack} data-attribute="ActiveAssetDashboard_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span>
                        Back
                    </div>
                </EventHandler>
                <div className='breadcrumbList'>
                    <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="ActiveAssetDashboard_Default_Breadcrumb" />
                </div>
            </div>

            <div className="mt-3 ActiveAssetDashboard">
                <div className='AssetDashboardRow row'>
                    <Col xs={12} sm={12} md={12} lg={12} xl={4}>
                        <div>
                            <Card data-attribute="ActiveAssetDashboard_Default_Card">
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div className='Assetdashboard_number'>
                                        <div className='Assetdashboard_number_heading'>
                                            <span className="heading">Asset #</span>
                                            <span className="value mx-2">{displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.assetNumber)}</span>
                                        </div>
                                        <div className={`${assetEoneDetails?.activeAsset?.activeAssetHeader?.assetStatus == true ? 'AssetDashboard_status' : 'AssetDashboard_status_Inactive'} `}>
                                            <span>{assetEoneDetails?.activeAsset?.activeAssetHeader?.assetStatus == true ? 'Active' : 'In Active'}</span>
                                        </div>
                                    </div>

                                    <div className='row mt-3 AssetDashboarddetails'>
                                        <Col xl={12} lg={12} md={12}>
                                            <div className='row mb-2'>
                                                <Col xl={12} lg={12} md={12}>
                                                    <div className="mb-2 mt-2 top-section">
                                                        <p>ASSET SUMMARY</p>
                                                    </div>
                                                </Col>
                                            </div>
                                        </Col>
                                        <Col xl={12} lg={12} md={12}>
                                            <div className='row mb-2'>
                                                <Col xl={6} lg={6} md={6}>
                                                    <Label  data-attribute="ActiveAssetDashboard_Default_Label">Vin/Serial #</Label>
                                                    <Tooltip
                                                        content={displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.vinNumber)}
                                                     data-attribute="ActiveAssetDashboard_Default_Tooltip">
                                                        <p>{displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.vinNumber)}</p>
                                                    </Tooltip>
                                                </Col>

                                                <Col xl={6} lg={6} md={6} className="leadr_order">
                                                    <Label data-attribute="ActiveAssetDashboard_Default_Label_2">LEADR Order Status</Label>
                                                    <span>{displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.orderRequestType)}</span>
                                                    <a href={onClickOrder(assetEoneDetails?.activeAsset?.activeAssetHeader?.orderRequestType, assetEoneDetails?.activeAsset?.activeAssetHeader?.orderNumber)} aria-label="LEADR Order Details"  target='_blank' rel='noreferrer noopener' className="LeadrDetails_value">{assetEoneDetails?.activeAsset?.activeAssetHeader?.orderNumber}</a>
                                                </Col>
                                            </div>

                                        </Col>

                                        <Col xl={12} lg={12} md={12}>
                                            <div className='row mb-2'>
                                                <Col xl={6} lg={6} md={6}>
                                                    <Label data-attribute="ActiveAssetDashboard_Default_Label_3">Unit/Barcode #</Label>
                                                    <Tooltip
                                                        content={displayValue(assetEoneDetails?.activeAsset?.unitId)}
                                                     data-attribute="ActiveAssetDashboard_Default_Tooltip_2">
                                                        <p>{displayValue(assetEoneDetails?.activeAsset?.unitId)}</p>
                                                    </Tooltip>
                                                </Col>

                                                <Col xl={6} lg={6} md={6} className="leadr_order">
                                                    <Label data-attribute="ActiveAssetDashboard_Default_Label_4">Item Status</Label>
                                                    <span>{displayValue(itemStatus)}</span>
                                                    
                                                </Col>
                                            </div>
                                        </Col>
                                        <Col xl={12} lg={12} md={12}>
                                            <div className='row mb-2'>
                                                <Col xl={6} lg={6} md={6}>
                                                    <Label data-attribute="ActiveAssetDashboard_Default_Label_5">Cost Center</Label>
                                                    <Tooltip
                                                        content={displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.costCenter)}
                                                     data-attribute="ActiveAssetDashboard_Default_Tooltip_3">
                                                        <p>{displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.costCenter)}</p>
                                                    </Tooltip>
                                                </Col>

                                               <Col xl={6} lg={6} md={6} className="leadr_order">
                                            <Label data-attribute="ActiveAssetDashboard_Default_Label_6">Description</Label>
                                            <Tooltip
                                                content={displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.description)}
                                             data-attribute="ActiveAssetDashboard_Default_Tooltip_4">
                                                <p>{displayValue(assetEoneDetails?.activeAsset?.activeAssetHeader?.description)}</p>
                                            </Tooltip>
                                        </Col>
                                            </div>
                                        </Col>
                                    </div>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div className='row mt-3 Childassets_details'>
                                        <div className="mb-1 mt-2 top-section">
                                            <p>CHILD ASSETS</p>
                                        </div>
                                        <Col xl={12} >
                                            <div className='mt-2 mb-2 childassests_content'>
                                                {assetEoneDetails?.activeAssetChildList?.length > 0 ?
                                                    assetEoneDetails?.activeAssetChildList?.map((item?: any, index?: number) => {
                                                        return (
                                                            <Col xl={6} lg={6} md={6} sm={12} xs={12} className="childleadr_order my-1 me-2">
                                                                <div className="childassests_info">
                                                                    <EventHandler onEvent={(e?: any) => onClickAssetNumber(e, item?.childAssetNumber)} data-attribute={`ActiveAssetDashboard_${(item?.childAssetNumber || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                                                        <a href="/" aria-label="LEADR Order Details" className="LeadrDetails_value">{item?.childAssetNumber}</a>
                                                                    </EventHandler>
                                                                    <Label className='m-0' data-attribute="ActiveAssetDashboard_Default_Label_7">{item?.netBookValue ? '$' + item?.netBookValue.toFixed(2) : '$ 0.00'}</Label>
                                                                </div>
                                                                <span>{item?.childAssetDescription}</span>
                                                            </Col>
                                                        )
                                                    }) : 'No Data'}
                                            </div>
                                        </Col>
                                    </div>
                                </Col>
                            </Card>
                        </div>
                        <div className="mt-3">
                            <Card data-attribute="ActiveAssetDashboard_Default_Card_2">
                                <div className="row">
                                    <Col lg={12} >
                                        <div className="Fuel_Cards">
                                            <span>FUEL CARDS</span>
                                            <img src={fuelcardicon} alt="1" className="Fuel_card_icon" />
                                        </div>
                                        <div>
                                            <div className='row mt-3'>
                                                <Col lg={6} md={6}>
                                                    <div className="Fuel_card_link">
                                                        <img src={linkicon} alt="1" className="Fuel_link_icon" />
                                                        <span className='mx-2'>View Fuel Card</span>
                                                    </div>
                                                </Col>

                                                <Col lg={6} md={6}>
                                                    <div className="Fuel_card_link">
                                                        <img src={linkicon} alt="1" className="Fuel_link_icon" />
                                                        <span className='mx-2'>Order Replacement</span>
                                                    </div>
                                                </Col>
                                            </div>
                                        </div>
                                    </Col>
                                </div>
                            </Card>
                        </div>

                        <div className='mt-3 mb-0 mb-md-3'>
                            <Card data-attribute="ActiveAssetDashboard_Default_Card_3">
                                <div className="top-section mb-3">
                                    <p>AUDIT HISTORY</p>
                                </div>
                                {assetEoneDetails?.activeAssetAuditHistory?.length > 0 ?
                                    assetEoneDetails?.activeAssetAuditHistory?.map((item?: any, index?: any) => {
                                        return (
                                            <EventHandler onEvent={(e?: any) => onClickAuditCycleYear(e, item)} data-attribute={`ActiveAssetDashboard_${(getAuditName(item) || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Audit_EventHandler`}>
                                                <div className={`audit-entry ${index != 0 && 'inactive'} ${item?.isScanned ? 'isScanned' : ''}`}>
                                                    <span>{getAuditName(item)}</span>
                                                </div>
                                            </EventHandler>
                                        )
                                    }) : 'No Data'}
                            </Card>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={8}>
                        <div>
                            <div className="Card_make_info">
                                <Card data-attribute="ActiveAssetDashboard_Default_Card_4">
                                    <div className='row'>
                                        <Col lg={12} className="card-container">

                                            <div className="info-card card-default card_icon_model">
                                                <div className="card-content">
                                                    <div className="card-label">Make / Model</div>
                                                    <div className="card-value">{assetEoneDetails?.activeAsset?.make ?? '-'} / {assetEoneDetails?.activeAsset?.model?.toString()?.length > 0 ? assetEoneDetails?.activeAsset?.model : '-'}</div>
                                                </div>
                                                <img src={modelicon} alt="1" className="card-icon" />
                                            </div>

                                            <div className="info-card card-orange">
                                                <div className="card-content">
                                                    <div className="card-label">Model Year</div>
                                                    <div className="card-value">{assetEoneDetails?.activeAsset?.year ?? '-'}</div>
                                                </div>
                                                <img src={yearicon} alt="1" className="card-icon" />
                                            </div>

                                            <div className="info-card card-blue">
                                                <div className="card-content">
                                                    <div className="card-label">Remaining Net Book Value</div>
                                                    <div className="card-value">{assetEoneDetails?.activeAsset?.remainingNetbookValue ? `$ ${assetEoneDetails?.activeAsset?.remainingNetbookValue}` : '$ 0.00'}</div>
                                                </div>
                                                <img src={dollaricon} alt="Dollar" className="card-icon" />
                                            </div>

                                            <div className="info-card card-default">
                                                <div className="card-content">
                                                    <div className="card-label owned_leased">OWNED / LEASED</div>
                                                    <div className="card-value">{assetEoneDetails?.activeAsset?.leasedVsOwned ?? '-'}</div>
                                                </div>
                                                <img src={companyicon} alt="1" className="card-icon" />
                                            </div>
                                        </Col>
                                    </div>

                                    <div className="row mt-2 assetmain">
                                        <Col lg={8} className="p-0">
                                            <div className="assetcontent_activeasset mb-3">
                                                <div className="mb-2 top-section">
                                                    <p>ASSET DETAILS</p>
                                                </div>
                                                <div className='row'>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_8">Company #</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.companyNumber ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_5">
                                                            <p>{assetEoneDetails?.activeAsset?.companyNumber ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_9">GL Category</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.glCategory ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_6">
                                                            <p>{assetEoneDetails?.activeAsset?.glCategory ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_10">EQ Class Code</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.eqClassCode ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_7">
                                                            <p>{assetEoneDetails?.activeAsset?.eqClassCode ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_11">Placed in Service</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.placedInService ? moment(assetEoneDetails?.activeAsset?.placedInService)?.format("MM/DD/YYYY") : '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_8">
                                                            <p>{assetEoneDetails?.activeAsset?.placedInService ? moment(assetEoneDetails?.activeAsset?.placedInService)?.format("MM/DD/YYYY") : '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_12">State</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.state ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_9">
                                                            <p>{assetEoneDetails?.activeAsset?.state ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_13">Useful Life in Months</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.usefulLifeMonths ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_10">
                                                            <p>{assetEoneDetails?.activeAsset?.usefulLifeMonths ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_14">Runrate Depreciation</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.runRateDepreciation ?? '$ 0.00'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_11">
                                                            <p>{assetEoneDetails?.activeAsset?.runRateDepreciation ?? '$ 0.00'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_15">Rem Life in Months</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.remainingLifeMonths ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_12">
                                                            <p>{assetEoneDetails?.activeAsset?.remainingLifeMonths ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_16">Current Month Depreciation</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.currentMonthDepreciation ?? '$ 0.00'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_13">
                                                            <p>{assetEoneDetails?.activeAsset?.currentMonthDepreciation ?? '$ 0.00'}</p>
                                                        </Tooltip>
                                                    </Col>

                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_17">License Expiration Date</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.licenseExpirationDate ? moment(assetEoneDetails?.activeAsset?.licenseExpirationDate)?.format("MM/DD/YYYY") : '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_14">
                                                            <p>{assetEoneDetails?.activeAsset?.licenseExpirationDate ? moment(assetEoneDetails?.activeAsset?.licenseExpirationDate)?.format("MM/DD/YYYY") : '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_18">License Plate #</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.licensePlateNumber ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_15">
                                                            <p>{assetEoneDetails?.activeAsset?.licensePlateNumber ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_19">EQ Class Description</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.eqClassDescription ?? '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_16">
                                                            <p>{assetEoneDetails?.activeAsset?.eqClassDescription ?? '-'}</p>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col lg={4} md={4} className="mb-3">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_20">Equipment Status</Label>
                                                        <Tooltip
                                                            content={assetEoneDetails?.activeAsset?.equipmentStatusDescription?.length ? assetEoneDetails?.activeAsset?.equipmentStatusDescription : '-'}
                                                         data-attribute="ActiveAssetDashboard_Default_Tooltip_17">
                                                            <p>{assetEoneDetails?.activeAsset?.equipmentStatusDescription?.length ? assetEoneDetails?.activeAsset?.equipmentStatusDescription : '-'}</p>
                                                        </Tooltip>
                                                    </Col>

                                                    <Col lg={4} md={4} className="mb-3">
                                                        <span className="dashboardAssetImage_label" aria-label="asset images" onClick={(e?: any) => onClickAssetImages(e)}>Asset Images</span>
                                                    </Col>
                                                </div>
                                            </div>

                                            <div className=" mt-2 mt-md-0 assetcontent_activeasset">
                                                <Col lg={12}>
                                                    <div className="mb-2 top-section">
                                                        <p>ASSET HISTORY</p>
                                                    </div>

                                                    <div className="assethistory_activeasset_table">
                                                        <SofturaTable
                                                            data={assetEoneDetails?.orderHistory}
                                                            columns={columns}
                                                            className="custom-class"
                                                            pagination={false}
                                                         data-attribute="ActiveAssetDashboard_Default_Grid" />
                                                    </div>
                                                </Col>

                                                <Col lg={12} className="mt-3">
                                                    <div className="top-section">
                                                        <p>ACCIDENT HISTORY</p>
                                                    </div>

                                                    <div className="assethistory_activeasset">
                                                        <div>
                                                            <div className='row mt-2'>
                                                                <Col lg={4} md={4}>
                                                                    <div className="Fuel_card_link">
                                                                        <img src={linkicon} alt="1" className="Fuel_link_icon" />
                                                                        <span className='mx-2'>File a Claim</span>
                                                                    </div>
                                                                </Col>

                                                                <Col lg={4} md={4}>
                                                                    <div className="Fuel_card_link">
                                                                        <img src={linkicon} alt="1" className="Fuel_link_icon" />
                                                                        <span className='mx-2'>Risk Connect</span>
                                                                    </div>
                                                                </Col>

                                                                <Col lg={4} md={4}>
                                                                    <div className="Fuel_card_link">
                                                                        <img src={linkicon} alt="1" className="Fuel_link_icon" />
                                                                        <span className='mx-2'>Current Claim</span>
                                                                    </div>
                                                                </Col>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </div>

                                            <div className="row mt-3">
                                                <Col lg={6} className="mb-0 mb-md-3">
                                                    <div className="Dvir_Dashboard assetcontent_activeasset">
                                                        <div className="mb-2 top-section">
                                                            <p>DVIR</p>
                                                        </div>
                                                        <div className='row'>
                                                            <Col lg={12} md={6} className="mb-3">
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_21">Last DVIR Inspect Date</Label>
                                                                <p>Coming Soon</p>
                                                            </Col>
                                                            <Col lg={6} md={6} className="mb-3">
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_22">Inspector</Label>
                                                                <p>Coming Soon</p>
                                                            </Col>
                                                            <Col lg={6} md={6} className="mb-3">
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_23">Failures</Label>
                                                                <p>Coming Soon</p>
                                                            </Col>
                                                            <Col lg={12} md={6}>
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_24">Branch</Label>
                                                                <p>{assetEoneDetails?.activeAsset?.branchNo ?? '-'}</p>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col lg={6} className="mt-0 mb-0 mb-md-3">
                                                    <div className="Maintainance_Dashboard assetcontent_activeasset">
                                                        <div className="mb-2 top-section">
                                                            <p>MAINTENANCE</p>
                                                        </div>
                                                        <div className="comming-soon">
                                                            <div>
                                                                <img className="comming-soon-img" src={comingsoon} alt="comming soon" />
                                                                <span className="mt-2 comming-soon-text">COMING SOON</span>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <Col lg={12} md={6} className="mb-3">
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_25">Vehicle Spend (Invoiced)</Label>
                                                                <p>-</p>
                                                            </Col>
                                                            <Col lg={12} md={6} className="mb-3">
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_26">Approved Spend (Not Invoiced)</Label>
                                                                <p>-</p>
                                                            </Col>
                                                            <Col lg={12} md={6}>
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_27">Recent Prenative Maintainance Date</Label>
                                                                <p>-</p>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </div>


                                        </Col>

                                        <Col lg={4} className="p-0 p-lg-0 px-lg-2 p-md-0 mt-md-3 mt-lg-0 ">
                                            <div className="driver_assignment_col">
                                                <div className="mb-2 top-section">
                                                    <p>DRIVER ASSIGNMENT</p>
                                                </div>

                                                <div className='row mb-2'>
                                                    <Col lg={12} >
                                                        <div className="Driver_Assignment_details">
                                                            <div>
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_28">{assetEoneDetails?.activeAsset?.driverAssignment?.driverName?.toString()?.length > 0 ? assetEoneDetails?.activeAsset?.driverAssignment?.driverName : '-'}</Label>
                                                                <p>{assetEoneDetails?.activeAsset?.driverAssignment?.employeeId ?? '-'}</p>
                                                            </div>
                                                            <div className="Driver_Assignment_Business">
                                                                <span>Wheels</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </div>

                                                <div className='row DriverDashboarddetails'>
                                                    <Col lg={5} md={6} className="p-0">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_29">Date Assigned</Label>
                                                        <p>{assetEoneDetails?.activeAsset?.driverAssignment?.dateAssigned ?? 'Coming Soon'}</p>
                                                    </Col>

                                                    <Col lg={7} md={6} className="leadr_order">
                                                        <Label data-attribute="ActiveAssetDashboard_Default_Label_30">Mileage Logged Date </Label>
                                                        <p>{assetEoneDetails?.activeAsset?.driverAssignment?.mileageLogDate ?? 'Coming Soon'}</p>
                                                    </Col>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <Col lg={12} xl={12} md={6}>
                                                    <div className='Telematics_col mt-3'>
                                                        <div className="mb-2 top-section">
                                                            <p>TELEMATICS / CAMERAS</p>
                                                        </div>

                                                        <div className="comming-soon">
                                                            <div>
                                                                <img className="comming-soon-img" src={comingsoon} alt="comming soon" />
                                                                <span className="mt-2 comming-soon-text">COMING SOON</span>
                                                            </div>
                                                        </div>

                                                        <div className='row TelematicsDashboarddetails'>
                                                            <Col lg={6} md={6} className="mb-2 md-lg-0 md-md-0 mb-sm-0">
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_31">Telematics System</Label>
                                                                <p>-</p>
                                                            </Col>

                                                            <Col lg={6} md={6} className="leadr_order">
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_32">Mileage Logged Date </Label>
                                                                <p>-</p>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col lg={12} xl={12} md={6}>
                                                    <div className='Documents_col mt-3'>
                                                        <div className="mb-2 top-section">
                                                            <p>DOCUMENTS</p>
                                                        </div>

                                                        <div className="comming-soon">
                                                            <div>
                                                                <img className="comming-soon-img" src={comingsoon} alt="comming soon" />
                                                                <span className="mt-2 comming-soon-text">COMING SOON</span>
                                                            </div>
                                                        </div>
                                                        <div className='row DocumentsDashboarddetails'>
                                                            <Col lg={12} md={12} className='link_policy'>
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_33">Insurance</Label>
                                                                <a href="/" aria-label="insurance policy" className="mx-3 disabled-link">Insurance Policy</a>
                                                            </Col>

                                                            <Col lg={12} md={12} className='link_policy'>
                                                                <Label data-attribute="ActiveAssetDashboard_Default_Label_34">Title</Label>
                                                                <a href="/" aria-label="View Title" className="mx-3 disabled-link" >View Title</a>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </div>
                                        </Col>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </Col >
                </div >
                {showModalPopup ?
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle={popupcontent?.header}
                        ModalPopupType={popupcontent?.size}
                        closeModalPopup={(e?: any) => closeModalPopup(e)} data-attribute="ActiveAssetDashboard_Default_ModalPopup">
                        <div >
                            {popupcontent?.popupType === 'audit' ? <ActiveAssetAuditHistory
                                auditHistoryDetails={auditHistoryDetails?.details}
                                audithistory_data={audithistory_data}
                                audithistory_columns={audithistory_columns}
                                handleLocationClick={handleLocationClick}
                                handleImageClick={handleImageClick}
                            /> :  <AssetImage />}
                        </div>
                    </ModalPopup>
                    : null}
            </div >
        </>
    )
}

export default ActiveAssetDashboard
